import {GitHubAvatar} from '@github-ui/github-avatar'
import {useGetHovercardAttributesForType} from '@github-ui/hovercards/use-get-hovercard-attributes-for-type'
import {Link} from '@primer/react'

import styles from './Participant.module.css'
import type {IssueSecondaryParticipantNode} from './participant-query-types'

type ParticipantFragment = Pick<IssueSecondaryParticipantNode, 'login' | 'avatarUrl'>

type ParticipantProps = {
  participant: ParticipantFragment
}

export function Participant({participant}: ParticipantProps) {
  const {login, avatarUrl} = participant
  const getHovercardAttributesForType = useGetHovercardAttributesForType()
  const hovercardAttrs = getHovercardAttributesForType('user', {login})

  return (
    <Link href={`/${login}`} {...hovercardAttrs}>
      <GitHubAvatar src={avatarUrl} size={20} alt={`@${login}`} className={styles.GitHubAvatar} />
    </Link>
  )
}
